import styled from 'styled-components';
import { IoIosArrowBack, IoIosArrowDown } from 'react-icons/io';

import { subMenuComponentBackground, primaryColorStrong, detailsBackground, primaryColor } from '../../config/colors';

export const SubMenuItemWrapper = styled.li`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-bottom: 15px;
  position: relative;
`;

export const SubMenuItemHeader = styled.div`
  height: 50px;
  width: 100%;
  background-color: ${subMenuComponentBackground};
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const SubMenuItemRibbon = styled.div`
  width: 22px;
  height: 100%;
  background-color: ${primaryColorStrong};
`;

export const SubMenuItemTitle = styled.p`
  padding: 10px 15px 10px 22px;
  font-weight: 500;
  font-size: 1.25rem;
`;

export const ArrowLeft = styled(IoIosArrowBack).attrs((props) => ({
  size: 18,
}))`
  stroke-width: 10; /* same as font-weight but for react icons */
`;

export const ArrowDown = styled(IoIosArrowDown).attrs((props) => ({
  size: 18,
}))`
  stroke-width: 10; /* same as font-weight but for react icons */
`;

export const ArrowWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  padding-right: 20px;
`;
